module.exports = __webpack_public_path__ + "static/media/rip.b3fff3f7.svg";